import { useState, useEffect } from 'react';
import { apiService } from '../services/api';

let cachedEvents = null;

export const useEvents = () => {
  const [events, setEvents] = useState(cachedEvents ?? []);
  const [loading, setLoading] = useState(cachedEvents === null);
  const [error, setError] = useState(null);

  useEffect(() => {
    apiService.getEvents()
      .then((data) => {
        cachedEvents = data;
        setEvents(data);
        setError(null);
      })
      .catch((err) => {
        setError(err.message);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return { events, loading, error };
};
